import { PIK_ID } from '../../../constants/pik_id';
import { INewbuilding } from '../../../types/newbuilding';
import { formatTime } from '../../../utils/formatters';

export const getWorkTime = (newbuilding: INewbuilding): string | undefined => {
  const builder = newbuilding.builderInfo;

  if (!builder) {
    return undefined;
  }

  const { workTimeInfo, id } = builder;

  if (workTimeInfo && (workTimeInfo.callFrom || workTimeInfo.callTo)) {
    let result = id === PIK_ID ? 'Принимаем звонки' : 'Офис работает';

    if (workTimeInfo.callFrom) {
      result += ` с ${formatTime(workTimeInfo.callFrom)}`;
    }

    if (workTimeInfo.callTo) {
      result += ` до ${formatTime(workTimeInfo.callTo)}`;
    }

    return result;
  }

  return undefined;
};
